export default __webpack_public_path__ + "static/media/cert1.c61c9fad.jpg";